{
  "lastModified": 1726045343931,
  "uri": "c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744",
  "yachtType": [
    "Motor"
  ],
  "description": "Designed and built in Australia by renowned yacht builder, Oceanfast, in\n2010, BIG SKY is now returned home for the first time to provide an unrivalled\ncharter experience onboard one of the Southern Hemisphere ‘s largest and\nmore extraordinary yachts.\n\nHer exterior has been meticulously designed to ensure guests experience the\nAustralian al-fresco lifestyle. From the Sun Deck, where the jacuzzi is\nintegrated into a huge sun bed bar and u-shaped lounge, to the undercover\ndining seating 11 guests on the upper deck aft; every corner of the boat offers\nspace, luxury and comfort. The Main Deck provides a more intimate lounging\narea while dual staircases lead you to the swim platform where the fun really\nbegins.\n\nBIG SKY runs with a neutral palette throughout, appealing to a wide variety of\ntastes and styles. Sumptuous linen offers up the best night sleep with\naccommodation for 11 guests. The huge full-beam Master suite is a sanctuary\nin its own right thanks to the large windows, deep bath and spacious King\nbed. The additional staterooms are located on the lower deck and include\nthree VIP cabins with Queen beds and one Triple cabin with Double bed and\npullman bunk; all cabins have their own en-suite.\n\nBIG SKY has something for everyone with one of the widest selection of\ncharter toys on any yacht worldwide. She is located in the heart of the Great\nBarrier Reef for optimum exploration of Australia’s stunning beaches and\nmarine life.",
  "blueprint": {
    "name": "BIG SKY",
    "images": [
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::712c9890-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::737eed00-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::850af5f0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::88f8d1f0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::8e7defc0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::904cbc50-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::9409eb60-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::9f5834e0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::54653c70-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::9f594650-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::a406efe0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::0bc311d0-b3b5-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::bebd9f00-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::bebe6250-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::bebd02c0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::bebded20-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::e5c86ee0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::3bbcfaf0-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::bebba330-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::beb9a760-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d25fddc0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d25e7e30-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::8f5399d0-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d2616460-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d263d560-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d2602be0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d262c3f0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d261d990-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d2638740-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d25a5f80-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d26227b0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d25d6cc0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d26275d0-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d25cd080-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d2631210-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::d260c820-b3b3-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::0763a4c0-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::07663cd0-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::07648f20-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::07677550-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::0767ea80-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::07626c40-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::07672730-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::0765a090-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}",
      "/media/media::image::c::7819198774::vessel::d5cc4d3c-fe8c-11ed-889f-43d4bb723744::assets::0766d910-b3b4-11ee-8bc8-a1378d0fd05d.jpeg/{imageVariant}"
    ],
    "make": "Oceanfast",
    "model": "",
    "maxCrew": 10,
    "sleeps": 11,
    "builtYear": 2010,
    "architect": "Oceanfast",
    "interiorDesigner": "",
    "refitYear": 2021,
    "topSpeed": "",
    "cruiseSpeed": 12,
    "fuelCapacity": "",
    "cruisingCapacity": "42",
    "cabinLayout": [
      {
        "label": "Master Cabin",
        "value": "1"
      },
      {
        "label": "VIP Cabins",
        "value": "3"
      },
      {
        "label": "Triple Cabin with pullman bunk",
        "value": "1"
      }
    ],
    "cabins": 5,
    "bathrooms": 5,
    "length": 48,
    "beam": 8.8,
    "draft": 2.6,
    "hullType": "",
    "hullConstruction": "",
    "tonnage": "",
    "superStructure": [],
    "amenities": [
      {
        "label": "Sun Deck Jacuzzi",
        "quantity": ""
      },
      {
        "label": "Sunbed bar",
        "quantity": ""
      },
      {
        "label": "U-shaped lounge",
        "quantity": ""
      },
      {
        "label": "Zero speed stabilisation system",
        "quantity": ""
      },
      {
        "label": "Lounge Area",
        "quantity": ""
      },
      {
        "label": "Swim Platform",
        "quantity": ""
      }
    ],
    "toys": [
      {
        "label": "Yamaha FX Wave runners",
        "quantity": 2
      },
      {
        "label": "Jet Flyboard",
        "quantity": 1
      },
      {
        "label": "Inflatable Waterslide",
        "quantity": ""
      },
      {
        "label": "full sets of dive gear including cylinders, regulators, BCD’s Dive Compressor",
        "quantity": 10
      },
      {
        "label": "Dive Compressor",
        "quantity": ""
      },
      {
        "label": "Snorkeling Equipment",
        "quantity": ""
      },
      {
        "label": "Lift Electric foil boards",
        "quantity": 2
      },
      {
        "label": "Inflatable jet-ski dock",
        "quantity": 1
      },
      {
        "label": "with boots and bindings for all sizes",
        "quantity": 2
      },
      {
        "label": "Katana Wakesurf",
        "quantity": 1
      },
      {
        "label": "Kneeboard",
        "quantity": 1
      },
      {
        "label": "Water-ski",
        "quantity": 1
      },
      {
        "label": "Seabobs",
        "quantity": 3
      },
      {
        "label": "Blackfin Paddleboards",
        "quantity": 2
      },
      {
        "label": "Glass bottom Kayaks",
        "quantity": 2
      },
      {
        "label": "Schiller Water Bikes",
        "quantity": 2
      },
      {
        "label": "Space Hopper Inflatable jet-ski dock",
        "quantity": ""
      },
      {
        "label": "Inflatable water toys",
        "quantity": ""
      },
      {
        "label": "Towable Toys",
        "quantity": ""
      },
      {
        "label": "E-foil",
        "quantity": 2
      },
      {
        "label": "Swim Platform",
        "quantity": 1
      },
      {
        "label": "3 Person Rave WaterBoggan Banana",
        "quantity": 1
      },
      {
        "label": "Fishing Equipment",
        "quantity": ""
      },
      {
        "label": "Beach Games",
        "quantity": ""
      }
    ],
    "entertainment": [],
    "tenders": [
      "1 x 34' / 10.36m Nortech 340 Sport Centre Console Tender with 3 x Mercury 300 HP engines",
      "4.8m Brig 480 Tender with 90 HP engine"
    ]
  },
  "crew": [],
  "pricing": {
    "weekPricingFrom": {
      "currency": "USD",
      "price": 18000000,
      "displayCurrency": "USD",
      "displayPrice": 18000000
    },
    "weekPricingTo": {
      "currency": "USD",
      "price": 18000000,
      "displayCurrency": "USD",
      "displayPrice": 18000000
    },
    "dayPricingFrom": {
      "currency": "USD",
      "price": 3000000,
      "displayCurrency": "USD",
      "displayPrice": 3000000
    },
    "dayPricingTo": {
      "currency": "USD",
      "price": 5000000,
      "displayCurrency": "USD",
      "displayPrice": 5000000
    },
    "pricingInfo": [
      {
        "name": "Term / Weekly",
        "effectiveDates": [],
        "pricing": {
          "currency": "USD",
          "charterFee": 18000000,
          "inputAmountTaxed": "NONE",
          "note": "Plus TAX + APA",
          "unit": "WEEK",
          "lineItems": [
            {
              "item": "Charter Fee",
              "quantity": 1,
              "unitPrice": 18000000,
              "amount": 18000000,
              "conditions": ""
            }
          ],
          "total": 18000000,
          "subTotal": 18000000,
          "totalTax": 0
        },
        "inclusionZones": [
          {
            "label": "Australia",
            "type": "Country",
            "category": [
              "Oceania",
              "Australia and New Zealand",
              "Australia"
            ],
            "coordinates": [
              134.10701705798022,
              -25.516879284507734
            ],
            "bbox": [
              112.908203125,
              -39.1455078125,
              153.61689453125,
              -10.0517578125
            ]
          },
          {
            "label": "Fiji",
            "type": "Sovereign country",
            "category": [
              "Oceania",
              "Melanesia",
              "Fiji"
            ],
            "coordinates": [
              19.643807969695064,
              -17.661387590807376
            ],
            "bbox": [
              -180,
              -21.705859375000003,
              180,
              -12.476953125000009
            ]
          },
          {
            "label": "Fr. Polynesia",
            "type": "Dependency",
            "category": [
              "Oceania",
              "Polynesia",
              "Fr. Polynesia"
            ],
            "coordinates": [
              -142.50019145276352,
              -15.455280067613575
            ],
            "bbox": [
              -151.51240234375,
              -20.87587890625001,
              -136.293896484375,
              -8.781542968750003
            ]
          },
          {
            "label": "New Caledonia",
            "type": "Dependency",
            "category": [
              "Oceania",
              "Melanesia",
              "New Caledonia"
            ],
            "coordinates": [
              164.90171182645585,
              -20.823707214840063
            ],
            "bbox": [
              159.92822265625,
              -22.6611328125,
              168.13906250000002,
              -19.11464843750001
            ]
          },
          {
            "label": "New Zealand",
            "type": "Country",
            "category": [
              "Oceania",
              "Australia and New Zealand",
              "New Zealand"
            ],
            "coordinates": [
              -18.677620423939118,
              -34.08865541316071
            ],
            "bbox": [
              -177.9579971999999,
              -52.60031327099995,
              178.84392337300005,
              -8.543226820999905
            ]
          },
          {
            "label": "Papua New Guinea",
            "type": "Sovereign country",
            "category": [
              "Oceania",
              "Melanesia",
              "Papua New Guinea"
            ],
            "coordinates": [
              148.28680057292468,
              -6.227213564811673
            ],
            "bbox": [
              140.84921106000002,
              -11.636325778999947,
              155.96753991000003,
              -1.3463680969999245
            ]
          }
        ],
        "exclusionZones": [],
        "petsAllowed": false
      },
      {
        "name": "Gold Service Package",
        "effectiveDates": [{
            "from": "2023-11-01T00:00:00Z",
            "to": "2024-03-01T23:59:59Z"
        }],
        "pricing": {
          "currency": "USD",
          "charterFee": 5000000,
          "inputAmountTaxed": "NONE",
          "unit": "HOUR",
          "lineItems": [
            {
              "item": "Charter Fee",
              "quantity": 4,
              "unitPrice": 1250000,
              "amount": 5000000,
              "conditions": ""
            }
          ],
          "total": 5000000,
          "subTotal": 5000000,
          "totalTax": 0
        },
        "inclusionZones": [
          {
            "label": "Australia",
            "type": "Country",
            "category": [
              "Oceania",
              "Australia and New Zealand",
              "Australia"
            ],
            "coordinates": [
              134.10701705798022,
              -25.516879284507734
            ],
            "bbox": [
              112.908203125,
              -39.1455078125,
              153.61689453125,
              -10.0517578125
            ]
          },
          {
            "label": "New Zealand",
            "type": "Country",
            "category": [
              "Oceania",
              "Australia and New Zealand",
              "New Zealand"
            ],
            "coordinates": [
              -18.677620423939118,
              -34.08865541316071
            ],
            "bbox": [
              -177.9579971999999,
              -52.60031327099995,
              178.84392337300005,
              -8.543226820999905
            ]
          }
        ],
        "exclusionZones": [],
        "petsAllowed": false
      }
    ]
  }
}